// Small model
// const streamId = 'ce9da4434d';
// const commitId = 'b0c94ffb36';
// const objectId = '962072c99be831d2cf39107620ca3e02';

// Large model
// const streamId = '081d90414a';
// const commitId = '9b8495175e';
// const objectId = '65c48e1fafb7dbcb1131c74f542cb258';

// new model
// const streamId = 'a5db78d2d1'; // projectId now
// const commitId = '33272637e2';
// const objectId = 'd4368a41e961d085e557d75f39d66c65';

// Note: commitId, objectId are from Commits DB table

const streamId = 'a5db78d2d1';
const commitId = 'af2376684e';
const objectId = '26fe913cade09d49738f4de2723a1f40';

export {
  streamId,
  objectId,
  commitId
};

// class HighlightExtension extends SelectionExtension {
//   public constructor(viewer: IViewer, protected cameraProvider: CameraController) {
//     super(viewer, cameraProvider)
//     const highlightMaterialData: SelectionExtensionOptions = {
//       selectionMaterialData: {
//         id: MathUtils.generateUUID(),
//         color: 0x04cbfb,
//         opacity: 1,
//         roughness: 1,
//         metalness: 0,
//         vertexColors: false,
//         lineWeight: 1,
//         stencilOutlines: StencilOutlineType.NONE,
//         pointSize: 4
//       }
//     }
//     this.setOptions(highlightMaterialData)
//   }

//   public unselectObjects(ids: Array<string>) {
//     if (!this._enabled) return
//     if (!this.selectedNodes.length) return

//     const nodes = []
//     for (let k = 0; k < ids.length; k++) {
//       nodes.push(...this.viewer.getWorldTree().findId(ids[k]))
//     }
//     this.clearSelection(
//       nodes.filter((node: TreeNode) => {
//         return this.selectedNodes.includes(node)
//       })
//     )
//   }

//   /** Disable default events */
//   protected onObjectClicked(selection: SelectionEvent) {
//     selection
//   }

//   protected onObjectDoubleClick(selection: SelectionEvent) {
//     selection
//   }

//   protected onPointerMove(e) {
//     e
//   }
// }
